/**
 * Takes a boolean and returns a 'Yes' for true, or 'No' for false.
 * @param {boolean | undefined} The value to check
 * @returns {string} The 'Yes' or 'No' string
 */
export default function yesNo(input: boolean | undefined): string {
  return input ? "Yes" : "No";
}
